import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';
import {
  TEAM_MANAGE_PERMISSIONS,
  INBOX_EDIT_PERMISSIONS,
  INBOX_MANAGE_PERMISSIONS,
  INBOX_AGENT_BOT_MANAGE_PERMISSIONS,
  LABEL_MANAGE_PERMISSIONS,
  LABEL_CREATE_PERMISSIONS,
  LABEL_EDIT_PERMISSIONS,
  LABEL_DELETE_PERMISSIONS,
  TASK_MANAGE_PERMISSIONS,
  TASK_CREATE_PERMISSIONS,
  TASK_EDIT_PERMISSIONS,
  TASK_DELETE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS,
  CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { RELEASE_NOTES_PERMISSIONS } from 'dashboard/routes/dashboard/settings/releaseNotes/releaseNotes.routes';

// Settings Sidebar Configuration
const settings = accountId => ({
  parentNav: 'settings',
  routes: [
    'agent_bots',
    'agent_list',
    'attributes_list',
    'auditlogs_list',
    'settings_billing',
    'general_settings_index',
    'general_settings',
    'labels_list',
    'settings_applications_integration',
    'settings_applications_webhook',
    'settings_applications',
    'settings_inbox_finish',
    'settings_inbox_list',
    'settings_inbox_new',
    'settings_inbox_show',
    'settings_inboxes_add_agents',
    'settings_inboxes_page_channel',
    'settings_whatsapp_templates',
    'settings_integrations_dashboard_apps',
    'settings_integrations_integration',
    'settings_integrations_webhook',
    'settings_integrations_google_sheets',
    'settings_integrations_google_calendar',
    'settings_integrations',
    'settings_tasks',
    'settings_teams_add_agents',
    'settings_teams_edit_finish',
    'settings_teams_edit_members',
    'settings_teams_edit',
    'settings_teams_finish',
    'settings_teams_list',
    'settings_teams_new',
    'sla_list',
    'release_notes_list',
    'custom_roles_list',
  ],
  menuItems: [
    {
      icon: 'briefcase',
      label: 'ACCOUNT_SETTINGS',
      key: 'account_settings',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/general`),
      toStateName: 'general_settings_index',
    },
    {
      icon: 'wallet-outline',
      label: 'BILLING',
      key: 'billing',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/billing`),
      toStateName: 'settings_billing',
      featureFlag: FEATURE_FLAGS.BILLING_SCREEN,
    },
    {
      icon: 'people',
      label: 'AGENTS',
      key: 'agents',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/agents/list`),
      toStateName: 'agent_list',
      featureFlag: FEATURE_FLAGS.AGENT_MANAGEMENT,
    },
    {
      icon: 'people-team',
      label: 'TEAMS',
      key: 'teams',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', TEAM_MANAGE_PERMISSIONS],
      },
      toState: frontendURL(`accounts/${accountId}/settings/teams/list`),
      toStateName: 'settings_teams_list',
      featureFlag: FEATURE_FLAGS.TEAM_MANAGEMENT,
    },
    {
      icon: 'mail-inbox-all',
      label: 'INBOXES',
      key: 'inboxes',
      hasSubMenu: false,
      meta: {
        permissions: [
          'administrator',
          INBOX_EDIT_PERMISSIONS,
          INBOX_MANAGE_PERMISSIONS,
          INBOX_AGENT_BOT_MANAGE_PERMISSIONS,
        ],
      },
      toState: frontendURL(`accounts/${accountId}/settings/inboxes/list`),
      toStateName: 'settings_inbox_list',
      featureFlag: FEATURE_FLAGS.INBOX_MANAGEMENT,
    },
    {
      icon: 'book-copy-outline',
      label: 'WHATSAPP_TEMPLATES_SETTINGS',
      key: 'whatsapp_templates',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/whatsapp-templates`),
      toStateName: 'settings_whatsapp_templates',
    },
    {
      icon: 'tag',
      label: 'LABELS',
      key: 'labels',
      hasSubMenu: false,
      meta: {
        permissions: [
          'administrator',
          LABEL_MANAGE_PERMISSIONS,
          LABEL_CREATE_PERMISSIONS,
          LABEL_EDIT_PERMISSIONS,
          LABEL_DELETE_PERMISSIONS,
        ],
      },
      toState: frontendURL(`accounts/${accountId}/settings/labels/list`),
      toStateName: 'labels_list',
      featureFlag: FEATURE_FLAGS.LABELS,
    },
    {
      icon: 'clipboard-task-list',
      label: 'TASKS',
      key: 'tasks',
      hasSubMenu: false,
      meta: {
        permissions: [
          'administrator',
          TASK_MANAGE_PERMISSIONS,
          TASK_CREATE_PERMISSIONS,
          TASK_EDIT_PERMISSIONS,
          TASK_DELETE_PERMISSIONS,
        ],
      },
      toState: frontendURL(`accounts/${accountId}/settings/tasks/list`),
      toStateName: 'settings_tasks',
    },
    {
      icon: 'code',
      label: 'CUSTOM_ATTRIBUTES',
      key: 'attributes',
      hasSubMenu: false,
      meta: {
        permissions: [
          'administrator',
          CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS,
          CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS,
          CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS,
          CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS,
        ],
      },
      toState: frontendURL(
        `accounts/${accountId}/settings/custom-attributes/list`
      ),
      toStateName: 'attributes_list',
      featureFlag: FEATURE_FLAGS.CUSTOM_ATTRIBUTES,
    },
    {
      icon: 'flash-on',
      label: 'INTEGRATIONS',
      key: 'integrations',
      hasSubMenu: false,
      // Todo usuário desde a #586: é onde mora a conexão da própria Google Agenda.
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/integrations`),
      toStateName: 'settings_applications',
      featureFlag: FEATURE_FLAGS.INTEGRATIONS,
    },
    {
      icon: 'key',
      label: 'AUDIT_LOGS',
      key: 'audit_logs',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/audit-logs/list`),
      toStateName: 'auditlogs_list',
      isEnterpriseOnly: true,
      featureFlag: FEATURE_FLAGS.AUDIT_LOGS,
    },
    {
      icon: 'info',
      label: 'RELEASE_NOTES',
      key: 'release_notes',
      hasSubMenu: false,
      meta: {
        permissions: RELEASE_NOTES_PERMISSIONS,
      },
      toState: frontendURL(`accounts/${accountId}/settings/release_notes/list`),
      toStateName: 'release_notes_list',
    },
    {
      icon: 'scan-person',
      label: 'CUSTOM_ROLES',
      key: 'custom_roles',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/custom-roles/list`),
      toStateName: 'custom_roles_list',
      isEnterpriseOnly: true,
      featureFlag: FEATURE_FLAGS.CUSTOM_ROLES,
      beta: true,
    },
    {
      icon: 'poll-outline',
      label: 'SURVEYS',
      key: 'surveys',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator', 'survey_view', 'survey_manage'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/surveys/list`),
      toStateName: 'surveys_list',
      featureFlag: FEATURE_FLAGS.SURVEYS,
    },
    {
      icon: 'document-list-clock',
      label: 'SLA',
      key: 'sla',
      hasSubMenu: false,
      meta: {
        permissions: ['administrator'],
      },
      toState: frontendURL(`accounts/${accountId}/settings/sla/list`),
      toStateName: 'sla_list',
      isEnterpriseOnly: true,
      featureFlag: FEATURE_FLAGS.SLA,
      beta: true,
    },
  ],
});

export default settings;
